/** Empty / error / offline copy for shop portal `/app/jobs`. Mirrors tech PWA Status/Orders. */

export const JOBS_EMPTY = {
    eyebrow: 'JOBS · EMPTY',
    headline: 'No shop jobs yet',
    body:
        'This shop has no jobs after a successful load. After invite signup you land here. The portal does not invent a placeholder job, a 0-job count, or treat a failed load as empty.',
    cta: 'Create job',
    note:
        'TRUE EMPTY · LIVE — Create job asks to confirm, then createShopJob writes pending only. This is not CREATE · SOT and not JOBS · ERROR or JOBS · OFFLINE. SoT EMPTY (jobsSot=empty) never writes.',
};

export const JOBS_EMPTY_SOT = {
    eyebrow: 'JOBS · EMPTY',
    headline: 'SoT empty — Create job is paint-only',
    body:
        'This is not a true-empty shop. fetchShopJobsWithTechs did not run. Create job opens CREATE · SOT. There is no confirm dialog. createShopJob does not run. Auto World is unchanged.',
    cta: 'Create job',
    note:
        'CREATE · SOT — no confirm, no write. True-empty confirm → createShopJob is a different path. Do not empty Auto World — use TRUE EMPTY · WALK (?trueEmptySot=walk).',
};

export const JOBS_TRUE_EMPTY_WALK = {
    eyebrow: 'TRUE EMPTY · WALK',
    headline: 'Confirm → createShopJob path (no write)',
    body:
        'This paints a successful zero-job load without emptying Auto World. Create job shows the live confirm dialog. createShopJob will not run. Auto World stays unchanged.',
    cta: 'Create job',
    note:
        'On a real zero-job shop the same confirm writes pending only. SoT EMPTY (jobsSot=empty) skips confirm and stays CREATE · SOT.',
};

export const JOBS_ERROR = {
    eyebrow: 'JOBS · ERROR',
    headline: 'Shop jobs could not load',
    body:
        'Shop jobs did not load. This is not an empty shop and not a 0-job count. Retry re-fetches fetchShopJobsWithTechs.',
    cta: 'Retry',
    note: 'Check your connection and shop claims, then retry. Create Job stays so you can still start work after a successful load.',
};

export const JOBS_OFFLINE = {
    eyebrow: 'JOBS · OFFLINE',
    headline: 'You are offline',
    body:
        'The shop portal cannot read jobs without a connection. This is not an empty shop. Cached counts stay hidden instead of showing 0.',
    cta: 'Retry',
    note: 'Reconnect, then retry. Retry re-checks the connection and re-fetches. Create Job stays so you can still start work once you are back online.',
};

export const JOBS_TAB_EMPTY = {
    pending: {
        eyebrow: 'PENDING · EMPTY',
        headline: 'No pending jobs in this list',
        body:
            'Nothing is waiting in Pending. Other tabs may still have shop jobs. This is not JOBS · EMPTY — that card is only for a shop with zero jobs.',
        cta: 'Create job',
        note: 'Check Active, Complete, or Cancelled, or create a job to start the queue.',
    },
    active: {
        eyebrow: 'ACTIVE · EMPTY',
        headline: 'No active jobs in this list',
        body:
            'Nothing is in progress. Other tabs may still have shop jobs. This is not JOBS · EMPTY — that card is only for a shop with zero jobs.',
        cta: 'Create job',
        note: 'Check Pending, Complete, or Cancelled, or create a job.',
    },
    complete: {
        eyebrow: 'COMPLETE · EMPTY',
        headline: 'No complete jobs in this list',
        body:
            'Nothing is finished yet. Other tabs may still have shop jobs. This is not JOBS · EMPTY — that card is only for a shop with zero jobs.',
        cta: 'Create job',
        note: 'Check Pending, Active, or Cancelled, or create a job.',
    },
    cancelled: {
        eyebrow: 'CANCELLED · EMPTY',
        headline: 'No cancelled jobs in this list',
        body:
            'Nothing is cancelled. Other tabs may still have shop jobs. This is not JOBS · EMPTY — that card is only for a shop with zero jobs.',
        cta: 'Create job',
        note: 'Check Pending, Active, or Complete, or create a job.',
    },
};

export const SHOP_JOBS_PREVIEW_VALUES = ['empty', 'error', 'offline', 'pending', 'pending-handoff', 'handoff', 'complete-handoff'];
export const SHOP_JOBS_SOT_VALUES = ['empty', 'error', 'offline', 'pending', 'pending-handoff', 'handoff', 'complete-handoff'];
export const SHOP_JOBS_DEV_PATH = '/dev/jobs';

export const SHOP_JOBS_PREVIEW_ERROR =
    'Local preview — fetchShopJobsWithTechs did not run.';

export const SHOP_JOBS_PREVIEW_NOTICE =
    'Local preview — empty / error / offline helper cards. Hosting production ignores jobsPreview.';

export const SHOP_JOBS_SOT_ERROR =
    'Shop SoT fixture — fetchShopJobsWithTechs did not run.';

export const SHOP_JOBS_SOT_NOTICE =
    'Shop SoT fixture — empty / error / offline helper cards. Hosting honors jobsSot for a signed-in shop user. fetchShopJobsWithTechs did not run. Auto World ready list is unchanged without this query. EMPTY Create job is CREATE · SOT (no confirm, no write) — not the true-empty confirm → createShopJob path. PENDING · HANDOFF paints one Demo Camry pending row. HANDOFF · ACTIVE paints the assignJob Active tab without a live write. COMPLETE · HANDOFF paints the completeJob Complete tab without a live write.';

export const SHOP_JOBS_PENDING_HANDOFF_NOTICE =
    'Shop SoT fixture — createShopJob Pending handoff. Hosting honors jobsSot=pending-handoff for a signed-in shop user. fetchShopJobsWithTechs did not run. This paints one Demo Camry pending row the way a live Create write appears. createShopJob did not run. Auto World is unchanged. Admin Live jobs Pending follows the same job without a hard refresh (jobsSot=pending-handoff). This is not PENDING · EMPTY, not a live write, and not ADAS.';

export const SHOP_JOBS_HANDOFF_NOTICE =
    'Shop SoT fixture — assignJob Active handoff. Hosting honors jobsSot=handoff for a signed-in shop user. fetchShopJobsWithTechs did not run. This paints one Demo Camry active row the way a live assignJob write appears on /app/jobs. DEMO WALK current step stays 4 with 1–3 done. Admin Active + PWA Active stay coherent on the same fixture. Auto World is unchanged. Only assignJob writes active. This is not ACTIVE · EMPTY, not leftover Pending, and not a live write. Never ADAS.';

export const SHOP_JOBS_COMPLETE_HANDOFF_NOTICE =
    'Shop SoT fixture — completeJob Complete continuity. Hosting honors jobsSot=complete-handoff for a signed-in shop user. fetchShopJobsWithTechs did not run. This paints one Demo Camry complete row the way a live completeJob write appears on /app/jobs. DEMO WALK current step stays 4 with 1–3 done. Admin Complete + PWA Complete stay coherent on the same fixture. Auto World is unchanged. Only completeJob writes complete. Never ADAS.';

export function shopJobsPreviewSurface(search, env = process.env.NODE_ENV) {
    if (env === 'production') return null;
    if (!search) return null;
    const raw = String(search).startsWith('?') ? String(search).slice(1) : String(search);
    const value = new URLSearchParams(raw).get('jobsPreview');
    if (SHOP_JOBS_PREVIEW_VALUES.includes(value)) return value;
    return null;
}

export function shopJobsSotSurface(search) {
    if (!search) return null;
    const raw = String(search).startsWith('?') ? String(search).slice(1) : String(search);
    const value = new URLSearchParams(raw).get('jobsSot');
    if (SHOP_JOBS_SOT_VALUES.includes(value)) return value;
    return null;
}

/** Hosting honors jobsSot only for a signed-in shop user. Local CRA can still use jobsPreview. */
export function shopJobsSotAllowed(input = {}) {
    return input.shopUser === true;
}

export function shopJobsSotActive(search, input = {}) {
    if (!shopJobsSotAllowed(input)) return null;
    return shopJobsSotSurface(search);
}

export const SHOP_JOBS_PATH = '/app/jobs';
export const SHOP_WALK_STATUS_VALUES = ['pending', 'active', 'complete'];
export const SHOP_WALK_SOT_VALUES = ['pending-handoff', 'handoff', 'complete-handoff'];
export const SHOP_PLAYGROUND_REGION_ID = 'ip6fSKveWZJOloXjEFeA';
export const SHOP_PREVIEW_TEST_REGION_ID = 'preview-test-region';
export const SHOP_PLAYGROUND_REGION_LABEL = 'colorado2';
export const SHOP_TEST_REGION_LABEL = 'Test Region';

function searchParams(search = '') {
    const raw = String(search).startsWith('?') ? String(search).slice(1) : String(search);
    return new URLSearchParams(raw);
}

function hrefFromParams(params) {
    const qs = params.toString();
    return qs ? `${SHOP_JOBS_PATH}?${qs}` : SHOP_JOBS_PATH;
}

export function isShopWalkStatus(value) {
    return value === 'pending' || value === 'active' || value === 'complete';
}

export function isShopWalkSot(value) {
    return value === 'pending-handoff' || value === 'handoff' || value === 'complete-handoff';
}

/** True when the shop jobs query already names a walk chip. */
export function shopSearchHasStatus(search = '') {
    return isShopWalkStatus(searchParams(search).get('status'));
}

export function shopStatusFromSearch(search = '') {
    const value = searchParams(search).get('status');
    return isShopWalkStatus(value) ? value : null;
}

export function shopSearchWithStatus(search = '', status) {
    const params = searchParams(search);
    if (!status || status === 'all') params.delete('status');
    else params.set('status', status);
    const qs = params.toString();
    return qs ? `?${qs}` : '';
}

/** Pending fixtures that stay on Open Pending / Pending-tab entry. Mirrors admin scoreboardLiveJobsEntryHref. */
export const SHOP_PENDING_ENTRY_JOBS_SOT = ['pending', 'pending-seed', 'pending-handoff'];

function isShopPendingEntryJobsSot(value) {
    return Boolean(value && SHOP_PENDING_ENTRY_JOBS_SOT.includes(value));
}

/**
 * Pending tab / DEMO WALK Open a Pending row.
 * Mirrors admin `scoreboardLiveJobsEntryHref`: keep leftover pending-seed /
 * pending-handoff / pending. Drop Active / Complete jobsSot (handoff /
 * complete-handoff) so Pending is not wearing Active / Complete. After
 * unify, write ?status=pending so entry does not fall to Seed.
 */
export function shopLiveJobsEntryHref(search = '') {
    const params = searchParams(search);
    const sot = params.get('jobsSot');
    if (sot && !isShopPendingEntryJobsSot(sot)) params.delete('jobsSot');
    const qs = params.toString();
    return `${SHOP_JOBS_PATH}${shopSearchWithStatus(qs ? `?${qs}` : '', 'pending')}`;
}

/**
 * Walk chip implied by a Hosting-safe jobsSot when ?status= is missing.
 * After unify, DEMO WALK fill follows ?status= — do not leave tabs on Seed.
 */
export function shopWalkStatusFromSot(search = '') {
    const sot = shopJobsSotSurface(search);
    if (sot === 'handoff') return 'active';
    if (sot === 'complete-handoff') return 'complete';
    if (sot === 'pending-handoff' || sot === 'pending') return 'pending';
    return null;
}

export function shopJobsSotHref(surface, search = '') {
    if (!SHOP_JOBS_SOT_VALUES.includes(surface)) return SHOP_JOBS_PATH;
    const existing = searchParams(search);
    existing.delete('jobsSot');
    existing.delete('status');
    const params = new URLSearchParams();
    const fromSot = shopWalkStatusFromSot(`?jobsSot=${surface}`);
    if (fromSot) params.set('status', fromSot);
    params.set('jobsSot', surface);
    existing.forEach((value, key) => params.set(key, value));
    return hrefFromParams(params);
}

/** List href for a jobsSot surface — walk fixtures keep their chip so back / switch stay coherent. */
export function shopJobsSotListHref(surface, search = '') {
    if (!SHOP_JOBS_SOT_VALUES.includes(surface)) return SHOP_JOBS_PATH;
    return shopJobsSotHref(surface, search);
}

/** Hosting / CRA fixture query keys Exit SoT must drop. */
export const SHOP_SOT_QUERY_KEYS = [
    'jobsSot',
    'createSot',
    'jobsPreview',
    'createPreview',
    'trueEmptySot',
    'trueEmptyPreview',
];

export function shopSearchWithoutSot(search = '') {
    const params = searchParams(search);
    SHOP_SOT_QUERY_KEYS.forEach((key) => params.delete(key));
    const sot = shopJobsSotSurface(search);
    if (sot && SHOP_WALK_SOT_VALUES.includes(sot)) {
        params.delete('status');
        params.delete('region');
    }
    const qs = params.toString();
    return qs ? `?${qs}` : '';
}

/** Exit jobsSot / createSot / previews → live shop list. No leftover walk query. */
export function shopJobsSotExitHref(search = '') {
    return `${SHOP_JOBS_PATH}${shopSearchWithoutSot(search)}`;
}

export function isShopTestRegionName(name) {
    return String(name || '').trim().toLowerCase() === SHOP_TEST_REGION_LABEL.toLowerCase();
}

export function shopRegionFromSearch(search = '') {
    return (searchParams(search).get('region') || '').trim();
}

export function shopRegionLabel(regionId, options = []) {
    const id = String(regionId || '').trim();
    if (id === SHOP_PLAYGROUND_REGION_ID) return SHOP_PLAYGROUND_REGION_LABEL;
    if (id === SHOP_PREVIEW_TEST_REGION_ID) return SHOP_TEST_REGION_LABEL;
    const found = options.find((option) => option.id === id);
    if (found?.label) {
        if (isShopTestRegionName(found.label)) return SHOP_TEST_REGION_LABEL;
        return found.label;
    }
    return id || SHOP_PLAYGROUND_REGION_LABEL;
}

/** Hosting-safe colorado2 ↔ Test Region while a walk jobsSot is on. Never invents ADAS ids. */
export function shopRegionSwitcherOptions(regionId = '') {
    const options = [
        { id: SHOP_PLAYGROUND_REGION_ID, label: SHOP_PLAYGROUND_REGION_LABEL },
        { id: SHOP_PREVIEW_TEST_REGION_ID, label: SHOP_TEST_REGION_LABEL },
    ];
    const id = String(regionId || '').trim();
    if (id && !options.some((option) => option.id === id)) {
        return [{ id, label: shopRegionLabel(id) }, ...options];
    }
    return options;
}

export function shopWalkRegionId(search = '', claimRegionId = '') {
    const fromQuery = shopRegionFromSearch(search);
    if (fromQuery) return fromQuery;
    const claim = String(claimRegionId || '').trim();
    if (claim === SHOP_PLAYGROUND_REGION_ID || claim === SHOP_PREVIEW_TEST_REGION_ID) return claim;
    return SHOP_PLAYGROUND_REGION_ID;
}

export const SHOP_LIVE_WRITE_REGION_ERROR =
    'preview-test-region is a Hosting fixture label, not a Firestore region. Live createShopJob uses the region document named Test Region from shop claims (regionId and shopId). This client will not invent that id.';

/** Fixture label is never a live write target. Real claim region ids pass. */
export function shopLiveWriteRegionError(regionId) {
    if (String(regionId || '').trim() === SHOP_PREVIEW_TEST_REGION_ID) return SHOP_LIVE_WRITE_REGION_ERROR;
    return null;
}

/**
 * Fixture walks keep the Hosting switcher (colorado2 ↔ preview-test-region).
 * Live pages follow shop claims and do not adopt preview-test-region from the query.
 */
export function shopDisplayRegionId(search = '', claimRegionId = '', fixtureWalk = false) {
    if (fixtureWalk) return shopWalkRegionId(search, claimRegionId);
    const claim = String(claimRegionId || '').trim();
    if (claim) return claim;
    return SHOP_PLAYGROUND_REGION_ID;
}

/**
 * Mid-DEMO WALK region switch keeps ?status= / jobsSot. From a jobsSot-only
 * URL, writes the matching chip so colorado2 ↔ Test Region does not fall to
 * Seed. Never uses Exit SoT.
 */
export function shopRegionWalkHref(regionId, search = '', jobStatus) {
    const params = searchParams(search);
    const id = String(regionId || '').trim() || SHOP_PLAYGROUND_REGION_ID;
    params.set('region', id);
    if (isShopWalkStatus(jobStatus)) {
        params.set('status', jobStatus);
    } else if (!shopSearchHasStatus(search)) {
        const fromSot = shopWalkStatusFromSot(search);
        if (fromSot) params.set('status', fromSot);
    }
    return hrefFromParams(params);
}

export function shopRegionWalkHint(regionLabel, regionId) {
    const label = String(regionLabel || '').trim() || 'this region';
    const id = String(regionId || '').trim() || 'region';
    return `${label} · ${id}. Switch rebinds DEMO WALK to this region. ?status= and jobsSot stay.`;
}

export function shopWalkStatusHref(search = '', status) {
    if (status === 'pending') return shopLiveJobsEntryHref(search);
    return `${SHOP_JOBS_PATH}${shopSearchWithStatus(search, status)}`;
}

/** Prefer Hosting-safe jobsSot, then Vite/CRA-only jobsPreview. */
export function shopJobsFixtureSurface(search, input = {}, env = process.env.NODE_ENV) {
    const sot = shopJobsSotActive(search, input);
    if (sot) return sot;
    return shopJobsPreviewSurface(search, env);
}

export function shopJobsFixtureNotice(search, input = {}, env = process.env.NODE_ENV) {
    if (shopJobsSotActive(search, input) === 'complete-handoff') return SHOP_JOBS_COMPLETE_HANDOFF_NOTICE;
    if (shopJobsSotActive(search, input) === 'handoff') return SHOP_JOBS_HANDOFF_NOTICE;
    if (shopJobsSotActive(search, input) === 'pending-handoff') return SHOP_JOBS_PENDING_HANDOFF_NOTICE;
    if (shopJobsSotActive(search, input)) return SHOP_JOBS_SOT_NOTICE;
    if (shopJobsPreviewSurface(search, env) === 'complete-handoff') return SHOP_JOBS_COMPLETE_HANDOFF_NOTICE;
    if (shopJobsPreviewSurface(search, env) === 'handoff') return SHOP_JOBS_HANDOFF_NOTICE;
    if (shopJobsPreviewSurface(search, env) === 'pending-handoff') return SHOP_JOBS_PENDING_HANDOFF_NOTICE;
    if (shopJobsPreviewSurface(search, env)) return SHOP_JOBS_PREVIEW_NOTICE;
    return null;
}

export function shopJobsFixtureError(kind) {
    return kind === 'sot' ? SHOP_JOBS_SOT_ERROR : SHOP_JOBS_PREVIEW_ERROR;
}

export function shopJobsPreviewJobs(surface) {
    if (surface === 'complete-handoff') {
        return [
            {
                id: 'sot-complete-handoff-1',
                status: 'complete',
                date: '2026-09-12 16:00',
                type: 'Install for Front',
                vehicle: { year: 2018, make: 'Toyota', model: 'Camry' },
                tech: { name: 'Demo tech' },
            },
        ];
    }
    if (surface === 'handoff') {
        return [
            {
                id: 'sot-handoff-1',
                status: 'active',
                date: '2026-09-12 14:00',
                type: 'Install for Front',
                vehicle: { year: 2018, make: 'Toyota', model: 'Camry' },
                tech: { name: 'Demo tech' },
            },
        ];
    }
    if (surface === 'pending-handoff') {
        return [
            {
                id: 'sot-pending-handoff-1',
                status: 'pending',
                date: '2026-09-12 14:00',
                type: 'Install for Front',
                vehicle: { year: 2018, make: 'Toyota', model: 'Camry' },
                tech: { name: '' },
            },
        ];
    }
    if (surface !== 'pending') return [];
    return [
        {
            id: 'preview-complete-1',
            status: 'complete',
            date: '2026-09-11 10:00',
            type: 'Install for Front',
            vehicle: { year: 2018, make: 'Toyota', model: 'Camry' },
            tech: { name: 'Preview tech' },
        },
    ];
}

export function statusSurfaceState(input) {
    const count = input.count;
    if (input.offline && count === 0) return 'offline';
    if (input.loading && count === 0) return 'loading';
    if (input.error && count === 0) return 'error';
    if (count === 0) return 'empty';
    return 'ready';
}

export function jobsListCopy(surface, emptyKind) {
    if (surface === 'offline') return JOBS_OFFLINE;
    if (surface === 'error') return JOBS_ERROR;
    if (surface === 'empty') {
        if (emptyKind === 'true-empty') return JOBS_TRUE_EMPTY_WALK;
        if (emptyKind === 'sot' || emptyKind === 'preview') return JOBS_EMPTY_SOT;
        return JOBS_EMPTY;
    }
    return null;
}

export function jobsEmptyCopyKind({ sot, preview, trueEmptyWalk } = {}) {
    if (trueEmptyWalk) return 'true-empty';
    if (sot === 'empty') return 'sot';
    if (preview === 'empty') return 'preview';
    return null;
}

export function jobsFilterEmptyCopy(loadedCount) {
    return `No shop jobs match this date in the ${loadedCount} loaded.`;
}

export function jobsFilterEmptyCard(loadedCount) {
    return {
        eyebrow: 'JOBS · FILTER',
        headline: 'No jobs on this date',
        body: jobsFilterEmptyCopy(loadedCount),
        cta: 'Clear date',
        note: 'Clear the date filter to see every loaded shop job. This is not JOBS · EMPTY.',
    };
}

/** Header must not treat a failed or pending load as “no pending jobs”. */
export function jobsHeaderDetail(input) {
    if (input.surface !== 'ready') return null;
    if (input.pendingCount > 0) return `Showing ${input.pendingCount} pending job(s)`;
    if ((input.activeCount || 0) > 0) return `Showing ${input.activeCount} active job(s)`;
    if ((input.completeCount || 0) > 0) return `Showing ${input.completeCount} complete job(s)`;
    if (input.loadedCount > 0) return 'No pending jobs in this list';
    return null;
}
